<template>
  <aside class="z-[99999] shadow-xl h-full absolute bg-light-900 dark:bg-dark-800 w-72 transition-all duration-300 ease-in-out" :class="[isSidebarOpen ? 'translate-x-0' : '-translate-x-full']">
    <div id="sidebar_top" class="px-4 py-3 flex items-center justify-between border-b border-gold-600/50 shadow-gold-600/20">
        <div class="h-12 w-40">
            <img src="@/assets/logo-horizontal.webp" alt="Logo" class="w-full h-full object-contain">
        </div>
        <button id="close-sidebar" class="p-2 rounded-lg transition-colors duration-200 hover:bg-primary-light dark:hover:bg-dark-700" @click="closeSidebar">
            <ArrowLeftIcon class="h-5 w-5 metallic-gold-icon transition-opacity duration-200 hover:opacity-90" />
        </button>
    </div>
    <div id="sidebar_main" class="overflow-y-auto px-4 py-7 max-h-[calc(100vh-100px)]">
        <template v-for="item in filteredMenuItems" :key="item.path">
            <RouterLink 
                :to="item.path" 
                :id="item.id" 
                class="mb-4 flex items-center px-3 py-2 text-dark-50/80 dark:text-primary/80 transition-all duration-400 group transition-colors duration-200"
                :class="{
                    'border-l-2 border-gold-400/90 text-gold-400/90 bg-gray-800': $route.path.startsWith(item.path),
                    'hover:border-l-2 hover:border-gold-400/90 hover:text-gold-400/90 hover:bg-gray-800': !$route.path.startsWith(item.path)
                }"
            >
                <component 
                    :is="item.icon" 
                    class="h-5 w-5 me-3"
                    :class="{
                        'text-gold-400/90': $route.path.startsWith(item.path),
                        'group-hover:text-gold-400/90': !$route.path.startsWith(item.path)
                    }"
                />
                {{ item.name }}
            </RouterLink>
        </template>
    </div>
  </aside>
</template>

<script>
import { ArrowLeftIcon, HomeIcon, ClipboardDocumentListIcon, CubeIcon, ClockIcon, CogIcon, ClipboardDocumentCheckIcon, UserGroupIcon, IdentificationIcon, BuildingLibraryIcon, DocumentTextIcon, ServerStackIcon, TableCellsIcon, CreditCardIcon, UsersIcon, CurrencyDollarIcon, BriefcaseIcon, PercentBadgeIcon, ChatBubbleLeftRightIcon, GiftIcon, BookmarkSquareIcon, BanknotesIcon, ArrowDownOnSquareIcon, ArrowUpOnSquareIcon, ArrowTrendingUpIcon, ExclamationTriangleIcon, WrenchScrewdriverIcon, BoltIcon, CircleStackIcon } from '@heroicons/vue/24/solid';

export default {
    name: 'SideBar',
    components: { ArrowLeftIcon, HomeIcon, ClipboardDocumentListIcon, CubeIcon, ClockIcon, CogIcon, ClipboardDocumentCheckIcon, UserGroupIcon, IdentificationIcon, BuildingLibraryIcon, DocumentTextIcon, ServerStackIcon, TableCellsIcon, CreditCardIcon, UsersIcon, CurrencyDollarIcon, BriefcaseIcon, PercentBadgeIcon, ChatBubbleLeftRightIcon, GiftIcon, BookmarkSquareIcon, BanknotesIcon, ArrowDownOnSquareIcon, ArrowUpOnSquareIcon, ArrowTrendingUpIcon, ExclamationTriangleIcon, WrenchScrewdriverIcon, BoltIcon, CircleStackIcon },
    data() {
        return {
            isSidebarOpen: false,
            menuItems: [
                { path: '/dashboard', name: 'Beranda', id: 'url-dashboard', icon: HomeIcon, permission: ['all'] },
                { path: '/marketing', name: 'Marketing', id: 'url-marketing', icon: ChatBubbleLeftRightIcon, permission: ['1','2'] },
                { path: '/table', name: 'Meja', id: 'url-table', icon: TableCellsIcon, permission: ['1', '2'] },
                { path: '/kitchen-division', name: 'Kitchen Division', id: 'url-kitchen-division', icon: BriefcaseIcon, permission: ['1','2'] },
                { path: '/global-discount', name: 'Global Discount', id: 'url-global-discount', icon: GiftIcon, permission: ['1','2'] },
                { path: '/kategori-item', name: 'Kategori Item', id: 'url-kategori-item', icon: BookmarkSquareIcon, permission: ['1'] },
                { path: '/item', name: 'Item', id: 'url-item', icon: CubeIcon, permission: ['1','2','3'] },
                { path: '/unit', name: 'Unit', id: 'url-unit', icon: BuildingLibraryIcon, permission: ['1','2'] },
                { path: '/petty-cash', name: 'Pengeluaran', id: 'url-pengeluaran', icon: BanknotesIcon, permission: ['1', '2','3'] },
                { path: '/riwayat-transaksi', name: 'Riwayat Transaksi', id: 'url-riwayat-transaksi', icon: ClockIcon, permission: ['1','2'] },
                { path: '/hutang', name: 'Piutang', id: 'url-hutang', icon: ClockIcon, permission: ['1','2'] },
                { path: '/cash-register', name: 'Daftar Cash Register', id: 'url-cash-register', icon: CurrencyDollarIcon, permission: ['1','2'] },
                { path: '/stock-opname', name: 'Stok Opname', id: 'url-stock-opname', icon: CircleStackIcon, permission: ['1','2'] },
                { path: '/inbound-items-form', name: 'Barang Masuk', id: 'url-inbound-items-form', icon: ArrowDownOnSquareIcon, permission: ['1','2'] },
                { path: '/outbound-items-form', name: 'Barang Keluar', id: 'url-outbound-items-form', icon: ArrowUpOnSquareIcon, permission: ['1','2'] },
                { path: '/report/daily-sales-order', name: 'Laporan Harian', id: 'url-report-daily-sales-order', icon: ArrowTrendingUpIcon, permission: ['1', '2'] },
                { path: '/report/all-sales-order', name: 'Laporan Semua Transaksi', id: 'url-report-all-sales-order', icon: ArrowTrendingUpIcon, permission: ['1', '2'] },
                { path: '/user', name: 'User', id: 'url-user', icon: UsersIcon, permission: ['1','2'] },
                { path: '/pengaturan', name: 'Pengaturan', id: 'url-pengaturan', icon: WrenchScrewdriverIcon, permission: ['1', '2'] },
                { path: '/role', name: 'Role & Permission', id: 'url-role-permission', icon: ExclamationTriangleIcon, permission: ['1', '2'] },
                { path: '/activity-log', name: 'Activity Log', id: 'url-activity-log', icon: BoltIcon, permission: ['1'] },
            ]
        }
    },
    computed: {
        filteredMenuItems() {
            const roleId = localStorage.getItem('role_id');
            const items = this.menuItems.filter(item => item.permission.includes(roleId) || roleId == 'null' || item.permission.includes('all'));
            return items;
        }
    },
    methods: {
        toggleSidebar() {
            this.isSidebarOpen = !this.isSidebarOpen;
        },
        closeSidebar() {
            this.isSidebarOpen = false;
            this.$emit('toggleBlur');
        }
    }
}
</script>

<style>
.metallic-gold-icon {
    color: #D4AF37;
    filter: drop-shadow(0 0 1px #FFD700);
}

.metallic-gold-bg {
    background-color: #D4AF37;
}

.metallic-gold-text {
    background: linear-gradient(145deg, #FFD700, #D4AF37, #B8860B);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}
</style>